<script lang="ts" setup>
import { computed } from 'vue';
import FieldChoice from '../../../properties/FieldChoice.vue';
import FieldCondition from '../../../properties/FieldCondition.vue';
import { Option } from '@/helpers/Interfaces';
import { FormBuilderContract } from '@/components/builder/form';
import { AlwaysChoice } from '@/components/builder/form/enums/AlwaysChoice';
import { NeverChoice } from '@/components/builder/form/enums/NeverChoice';
import { WhenChoice } from '@/components/builder/form/enums/WhenChoice';
import { TableType } from '..';

defineOptions({
    name: 'can-delete-row',
    components: {
        'field-choice': FieldChoice,
        'field-condition': FieldCondition
    }
});

const props = defineProps({
  "blueprint": null,
  "form": null,
  "label": { default: null }
});
const blueprint = computed(() => props.blueprint);

const requiredOptions: Option<AlwaysChoice | NeverChoice | WhenChoice>[] = [
    { value: AlwaysChoice.Always, text: '[[[Zawsze]]]' },
    { value: NeverChoice.Never, text: '[[[Nigdy]]]' },
    { value: WhenChoice.When, text: '[[[Warunkowo]]]' }
];
</script>

<template>
    <div>
        <field-choice v-model="blueprint.canDeleteRow" :options="requiredOptions" :label="label || $t('[[[Pozwól na usuwanie wierszy]]]')" />
        <field-condition v-model="blueprint.canDeleteRowWhen" :label="label" :show-label="false" :form="form" :when="blueprint.canDeleteRow" />
    </div>
</template>

